module.exports = __webpack_public_path__ + "img/en_layers.abf8697b.png";